import FormHeader from './form-header.vue'
FormHeader.install = function (Vue) {
  Vue.component(FormHeader.name, FormHeader);
};
export default FormHeader



// WEBPACK FOOTER //
// ./src/omnis-business/form-header/index.js